import { useDashboard } from '@cobliteam/dashboard/src/providers/DashboardProvider';
import DrawerPageInfo from './components/DrawerPageInfo';

const PageInfo = () => {
  const { sidebar } = useDashboard();
  const supportUID = sidebar?.route?.support?.uid;

  if (!supportUID) return null;

  return <DrawerPageInfo supportUID={supportUID} />;
};
export default PageInfo;
